import React, { useEffect } from 'react'
import { img_path } from '../../../../../environment'
import ImageWithBasePath from '../../../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs';
import DateComp from '../../../../../core/common/dateComponent/DateComp';
import { useGetAddendaAgreementQuery } from '../../../../../services/EndPointsApis';
import FormattedNumber from '../../../../../core/common/textFields/FormatNumber';
import logo from 'assests/img/airoomlogo.png'


const AddendaCard = ({ addendaId, projectId, printRef, onRenderReady, addendaData, key, saleInfoDataForPdf }: any) => {

    const newDate = Date.now()
    const formattedDate = dayjs(newDate).format('YYYY-MM-DD HH:mm:ss');

    // const RevisedContractAmount = addendaData?.result?.allAddenda?.reduce((sum: any, data: any) =>
    //     sum + data.saleAmount, 0
    // )
    const RevisedContractAmount = addendaData?.result?.currentReviewedAndApproved?.reduce((sum: number, data: any) =>
        data.status === "Approved" || data.status === "Reviewed" ? sum + data.saleAmount : sum, 0
    );
    const previousAmount = addendaData?.result?.projectPaymentSchedule?.reduce((sum: any, data: any) =>
        sum + data.paymentAmt, 0
    )
    const proposedAmount = addendaData?.result?.projectPaymentSchedule?.reduce((sum: any, data: any) =>
        sum + data.changeBy, 0
    )
    const newAmount = addendaData?.result?.projectPaymentSchedule?.reduce((sum: any, data: any) =>
        sum + data.newAmount, 0
    )

    const sumRevisedContractAmount = RevisedContractAmount + addendaData?.result?.originalContract?.saleAmount

    const formatComma = (num: number | string) => {
        if (num === null || num === undefined) return "0.0";
        const numericValue = String(num).replace(/,/g, "");
        if (isNaN(Number(numericValue))) return String(num);
        return Number(numericValue).toLocaleString();
    };
    useEffect(() => {
        if (addendaData && onRenderReady) {
            onRenderReady();
        }
    }, [addendaData]);

    const totalAmount = saleInfoDataForPdf?.result?.projectPaymentReceivableList?.projectPaymentReceivable?.reduce((sum: any, item: any) =>
        sum + (item?.amount || 0),
        0
    ) || 0

    return (
        <>
            <div className='row px-5' id="pdf-content" ref={printRef} key={key} >
                <div style={{ height: "280mm", backgroundColor: "#ffffffff", padding: "2rem", overflow: "hidden", pageBreakAfter: "always" }}>
                    <div className='text-end' style={{ marginLeft: '-60px' }}>
                        <h5>{addendaId?.addendaNbr}</h5>
                        {addendaId?.status ?
                            <h5>({addendaId?.status})</h5>
                            : ''}
                    </div>
                    <div className='col-md-12'>
                        <div className='d-flex gap-2 align-items-center'>
                            <div>
                                <ImageWithBasePath
                                    src="assets/img/logo.svg"
                                    className=""
                                    alt="Logo"
                                    width={120}
                                    height={68}
                                />
                            </div>
                            <div className='mt-2 fs-12'>
                                <p className='mb-0'>
                                    <b>AIROOM, LLC</b>
                                    <br />
                                    <b>
                                        Address {" "}
                                    </b>
                                    6825 N. Lincoln Ave., Lincolnwood, IL 60712  <br />
                                    <b> BRANCH OFFICE</b> 36 S. Washington, Hinsdale, IL  60521
                                </p>
                                <p>
                                    Phone: 847-763-1100  - 847.763.1101  - <Link to="https:/www.airoom.com" className='text-decoration-underline text-primary'>www.airoom.com</Link>
                                </p>
                            </div>
                        </div>
                        <h4 className='mt-5 mb-3 text-center'>{addendaId?.addendaNbr?.includes('SLS') ? 'Sales' : 'Field'} Contract Addendum</h4>
                        <div className='row fs-12'>
                            <div className='col-md-7' style={{ flex: '0 0 58.3333%', maxWidth: '58.3333%' }}>
                                <div className='d-flex'>
                                    <p className='w-35 mb-0 fw-600' style={{ width: '35%' }}>
                                        Buyer :
                                    </p>
                                    <p className='mb-0 w-75' style={{ width: '75%' }}>
                                        {addendaData?.result?.addendaContactInfo?.buyer}

                                    </p>
                                </div>
                                <div className='d-flex'>
                                    <p className='w-35 mb-0 fw-600' style={{ width: '35%' }}>
                                        Address :
                                    </p>
                                    <p className='mb-0 w-75' style={{ width: '75%' }}>
                                        {addendaData?.result?.addendaContactInfo?.address}

                                    </p>
                                </div>
                                <div className='d-flex'>
                                    <p className='w-35 mb-0 fw-600' style={{ width: '35%' }}>
                                        City, State, Zip :
                                    </p>
                                    <p className='mb-0 w-75' style={{ width: '75%' }}>
                                        {addendaData?.result?.addendaContactInfo?.cityStateZip}

                                    </p>
                                </div>
                                <div className='d-flex '>
                                    <p className='w-35 mb-0 fw-600' style={{ width: '35%' }}>
                                        Project Address :
                                    </p>
                                    <p className='mb-0 w-75' style={{ width: '75%' }}>
                                        {addendaData?.result?.addendaContactInfo?.projectAddress}
                                    </p>
                                </div>
                            </div>
                            <div className='col-md-5 mb-2' style={{ flex: '0 0 41.6667%', maxWidth: '41.6667%' }}>
                                <div className='br-gray px-1 mb-1'>
                                    <div className='d-flex'>
                                        <p className='w-35 mb-0 fw-600' style={{ width: '35%' }}>
                                            Date :
                                        </p>
                                        <p className='mb-0'>
                                            <DateComp formattedDate={addendaData?.result?.addendaContactInfo?.date} />
                                        </p>
                                    </div>
                                    <div className='d-flex'>
                                        <p className='w-35 mb-0 fw-600' style={{ width: '35%' }}>
                                            Written By :
                                        </p>
                                        <p className='mb-0'>
                                            {addendaData?.result?.addendaContactInfo?.writtenBy}
                                        </p>
                                    </div>
                                </div>
                                <div className='d-flex'>
                                    <p className='w-35 mb-0 fw-600' style={{ width: '35%' }}>
                                        Home Phone :
                                    </p>
                                    <p className=' ms-1 mb-0'>
                                        {addendaData?.result?.addendaContactInfo?.homePhone}

                                    </p>
                                </div>
                                <div className='d-flex'>
                                    <p className='w-35 mb-0 fw-600' style={{ width: '35%' }}>
                                        Work Phone :
                                    </p>
                                    <p className=' ms-1 mb-0'>
                                        {addendaData?.result?.addendaContactInfo?.workPhone}

                                    </p>
                                </div>
                                <div className='d-flex'>
                                    <p className='w-35 mb-0 fw-600' style={{ width: '35%' }}>
                                        Project :
                                    </p>
                                    <p className='mb-0 ms-2'>
                                        {addendaData?.result?.addendaContactInfo?.projectNo}

                                    </p>
                                </div>
                            </div>
                            <div style={{ border: '1px solid' }} />
                        </div>
                        <h6 className='fs-13 p-1'>Please Enter the following Changes On my Order:</h6>
                        <div className='row mt-1 fs-12' style={{ borderTop: '2px solid', borderBottom: '2px solid' }}>
                            <div className='col-md-11' style={{ flex: '0 0 91.6667%', maxWidth: '91.6667%' }}>
                                <p className='mb-0 pt-1'
                                    style={{
                                        borderRight: '2px solid',
                                        height: addendaData?.result?.externalDurationTimeLine ? '200px' : '250px',
                                    }}                            >
                                    {addendaData?.result?.description}
                                </p>
                                {addendaData?.result?.externalDurationTimeLine > 0 &&
                                    <div className='fw-700 ' style={{ borderRight: '2px solid' }}>
                                        <p className='mb-3'>
                                            THIS ADDENDUM/CHANGE ORDER WILL RESULT IN ADDITIONAL <br />
                                            TIME FOR OFFICE PROCESSING, ORDERING AND SCHEDULING.
                                        </p>
                                        <p className='mt-3 mb-1'>
                                            THE WORK OUTLINED WILL EXTEND YOUR PROJECT'S ESTIMATED <br />

                                            <div>
                                                TIME OF COMPLETION BY APPROXIMATELY {addendaData?.result?.externalDurationTimeLine} DAYS.
                                            </div>
                                        </p>

                                    </div>
                                }

                            </div>
                            <div className='col-md-1 pt-1 fs-12' style={{ flex: '0 0 8.3333%', maxWidth: '8.3333%' }}>
                                <FormattedNumber value={addendaData?.result?.addendaContactInfo?.currentAddendaAmount} />
                            </div>

                        </div>

                        <>
                            <p className='mb-0 fs-12'>
                                This ADDENDUM becomes part of original Sales Contract dated <span><DateComp formattedDate={addendaData?.result?.saleDate} />
                                </span> and all the Conditions set forth there in.

                            </p>
                            <p className='fw-700 mb-0 fs-12'>
                                ALL ARCHITECTURAL SERVICES UNDER THIS CONTRACT WILL BE PROVIDED BY AIROOM ARCHITECTS,Corp.
                            </p>
                        </>
                        <div className='row' style={{ borderTop: '2px solid' }}>
                            <div className='d-flex justify-content-between align-items-center'>
                                <div className='d-flex w-50'>
                                    <p className='fw-700 mb-0 fs-12'>
                                        Amount Of This Addendum <span className='text-decoration-underline'>
                                            <FormattedNumber value={addendaData?.result?.addendaContactInfo?.currentAddendaAmount} />
                                        </span>
                                    </p>
                                </div>
                                <div className='d-flex w-50 align-items-center '>
                                    <h5 className='w-25 fw-700 mb-0 fs-12'>
                                        With <span className='text-decoration-underline'>
                                            <FormattedNumber value={addendaData?.result?.amountPaidUponAcceptance} />
                                        </span>
                                    </h5>
                                    <div className='d-flex flex-column'>
                                        <p className='fw-700 mb-0 fs-12'>
                                            PAYABLE UPON ACCEPTANCE
                                        </p>
                                        <p className='fs-9'>
                                            Credit Addendum to be deducted from final payment.

                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='row' style={{ borderTop: '2px solid', borderBottom: '2px solid' }}>
                            <div className='col-md-6' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                                <div className='mb-0' style={{ borderRight: '2px solid' }}>
                                    <h4 className='text-center'>BUYER: IMPORTANT NOTICE</h4>
                                    <div style={{ borderBottom: '2px solid' }}></div>
                                    <p className='mb-0 fs-12'>
                                        Changing your order cannot proceed until signed ADDENDUM is
                                        received and accepted by AIROOM, LLC. and paid in full by BUYER.
                                        This ADDENDUM will extend the completion of your project.
                                    </p>
                                </div>
                            </div>
                            <div className='col-md-6 pt-1' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                                <div className='d-flex align-items-center mt-2'>
                                    <p className='w-25 mb-0'>
                                        Buyers Apporval
                                    </p>
                                    <div className='d-flex flex-column w-100'>
                                        <div className='d-flex w-100 gap-2 align-items-baseline'>
                                            <div> X  </div>
                                            <div className='w-100' style={{ borderBottom: '1px solid' }}></div>
                                        </div>
                                        <div className='d-flex w-100 gap-2 align-items-baseline'>
                                            <div> X  </div>
                                            <div className='w-100' style={{ borderBottom: '1px solid' }}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p className='text-center mb-0'>DO NOT WRITE BELOW</p>
                        <div className='row mt-1' style={{ borderTop: '2px solid', borderBottom: '2px solid' }}>
                            <div className='col-md-6 p-0' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                                <div className='mb-0 pt-1 pb-1' style={{ borderRight: '2px solid' }}>
                                    <div className='d-flex gap-3' style={{ borderBottom: '1px solid' }}>
                                        <p className='mb-0 w-75 fs-12'>
                                            Date ADDENDUM received from Buyer
                                        </p>
                                        <p className='mb-0'>
                                            /
                                        </p>
                                        <p className='mb-0'>
                                            /
                                        </p>
                                    </div>
                                    <div className='d-flex gap-3' style={{ borderBottom: '1px solid' }}>
                                        <p className='mb-0 w-75 fs-12'>
                                            Date ADDENDUM accepted by AIROOM, LLC.
                                        </p>
                                        <p className='mb-0'>
                                            /
                                        </p>
                                        <p className='mb-0'>
                                            /
                                        </p>
                                    </div>
                                    <div className='d-flex gap-3' style={{ borderBottom: '1px solid' }}>
                                        <p className='mb-0 w-75 fs-12'>
                                            Construction changes received on
                                        </p>
                                        <p className='mb-0'>
                                            /
                                        </p>
                                        <p className='mb-0'>
                                            /
                                        </p>
                                    </div>
                                    <div className='d-flex gap-3' >
                                        <p className='mb-0 w-75 fs-12'>
                                            Changes made on
                                        </p>
                                        <p className='mb-0'>
                                            /
                                        </p>
                                        <p className='mb-0'>
                                            /
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6 pt-1 p-0' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                                <div className='w-100'>
                                    <p className='mb-0' style={{ borderBottom: '1px solid' }}>
                                        <span className='ms-1'>By</span>
                                    </p>
                                    <p className='mb-0' style={{ borderBottom: '1px solid' }}>
                                        <span className='ms-1'>By</span>

                                    </p>
                                    <p className='mb-0' style={{ borderBottom: '1px solid' }}>
                                        <span className='ms-1'>By</span>

                                    </p>
                                    <p className='mb-0'>
                                        <span className='ms-1'>By</span>

                                    </p>
                                    {/* <div className='d-flex flex-column'>
                                    <p> X <span className='text-decoration-underline'></span> </p>
                                    <p> X <span className='text-decoration-underline'></span> </p>
                                </div> */}
                                </div>
                            </div>
                        </div>
                        <div className='d-flex justify-content-end gap-5 mt-5'>
                            {/* <div>
                                <p className='mb-0' style={{ borderBottom: '2px solid', width: '100px' }}>

                                </p>
                                <p className='mb-0 fw-600'>
                                    Initials
                                </p>
                            </div> */}
                            <div>
                                <p className='mb-0' style={{ borderBottom: '2px solid', width: '100px' }}>

                                </p>
                                <p className='mb-0 fw-600'>
                                    Initials
                                </p>
                            </div>
                            <div>
                                <p className='mb-0' style={{ borderBottom: '2px solid', width: '100px' }}>

                                </p>
                                <p className='mb-0 fw-600'>
                                    Date
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div >
                    <div className="print-page" style={{ pageBreakAfter: "always" }} >
                        <div className='row p-5 '>
                            <div className='text-end mt-5' style={{ marginLeft: '15px' }}>
                                <h5>{addendaId?.addendaNbr}</h5>
                                {addendaId?.status ?
                                    <h5>({addendaId?.status})</h5>
                                    : ''}
                            </div>
                            <div className='col-md-12 text-center mt-3'>
                                <h4>
                                    Airoom,LLC.
                                </h4>
                                <h5>
                                    Revised Stage Payout Agreement
                                </h5>
                            </div>
                            <div className='row mt-4 fs-12'>
                                <div className='col-md-7' style={{ flex: '0 0 58.3333%', maxWidth: '58.3333%' }}>
                                    <div className='d-flex'>
                                        <p className='w-35 mb-0 fw-600'>
                                            Buyer :
                                        </p>
                                        <p className='mb-0 w-75'>
                                            {addendaData?.result?.addendaContactInfo?.buyer}
                                        </p>
                                    </div>
                                    <div className='d-flex '>
                                        <p className='w-35 mb-0 fw-600'>
                                            Address :
                                        </p>
                                        <p className='mb-0 w-75'>
                                            {addendaData?.result?.addendaContactInfo?.address}

                                        </p>
                                    </div>
                                    <div className='d-flex'>
                                        <p className='w-35 mb-0 fw-600'>
                                            City, State, Zip :
                                        </p>
                                        <p className='mb-0 w-75'>
                                            {addendaData?.result?.addendaContactInfo?.cityStateZip}
                                        </p>
                                    </div>
                                    <div className='d-flex'>
                                        <p className='w-35 mb-0 fw-600'>
                                            Project Address :
                                        </p>
                                        <p className='mb-0 w-75'>
                                            {addendaData?.result?.addendaContactInfo?.projectAddress}
                                        </p>
                                    </div>
                                </div>
                                <div className='col-md-5 mb-2' style={{ flex: '0 0 41.6667%', maxWidth: '41.6667%' }}>
                                    <div className='d-flex'>
                                        <p className='w-35 mb-0 fw-600'>
                                            Home Phone :
                                        </p>
                                        <p className='mb-0'>
                                            {addendaData?.result?.addendaContactInfo?.homePhone}

                                        </p>
                                    </div>
                                    <div className='d-flex'>
                                        <p className='w-35 mb-0 fw-600'>
                                            Work Phone :
                                        </p>
                                        <p className='mb-0'>
                                            {addendaData?.result?.addendaContactInfo?.workPhone}

                                        </p>
                                    </div>

                                </div>
                            </div>
                            <div className='col-md-9 mt-2 mb-2'>
                                <h5> Revised Contract</h5>
                            </div>
                            <div className='col-md-9 mb-2'>
                                <table className="table border-style-none">
                                    <thead className="table-light" style={{ borderBottom: '2px solid', borderTop: '2px solid' }}>
                                        <tr>
                                            <th className=' fs-12 p-1'>Nbr</th>
                                            <th className=' fs-12 p-1'>Date</th>
                                            <th className=' fs-12 p-1 text-end'>Sale Amt</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className=' fs-12 p-1'>
                                                Original Contract
                                            </td>
                                            <td className=' fs-12 p-1'>
                                                <DateComp formattedDate={addendaData?.result?.originalContract?.addendaDate} />
                                            </td>
                                            <td className=' fs-12 p-1 text-end'>
                                                <FormattedNumber value={addendaData?.result?.originalContract?.saleAmount} />
                                            </td>
                                        </tr>
                                        {addendaData?.result?.currentReviewedAndApproved?.map((data: any, index: any) => {
                                            return (
                                                <tr key={data?.id}>
                                                    <td className=' fs-12 p-1'>
                                                        {data?.addendaNumber} {addendaId?.addendaNbr === data?.addendaNumber ? `(Current Addendum-Status : ${addendaId?.status}) ` : ''} {data?.status === 'Approved' ? '' : data?.status !== 'Reviewed' ? '*' : data?.status !== 'Pending' ? "**" : '*'}
                                                    </td>
                                                    <td className=' fs-12 p-1'>
                                                        <DateComp formattedDate={data?.addendaDate} />
                                                    </td>
                                                    <td className=' fs-12 p-1 text-end'>
                                                        <FormattedNumber value={data?.saleAmount} />
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                    <tfoot style={{ borderBottom: '2px solid', borderTop: '2px solid' }}>
                                        <tr className='border-style-none' >
                                            <td colSpan={2} className="text-end color-red p-1 text-decoration-underline" ><strong>Revised Contract Amount*</strong></td>
                                            <td className='color-red  p-0 text-end'><strong className='ms-2'>
                                                <FormattedNumber value={sumRevisedContractAmount} />
                                            </strong></td>
                                        </tr>
                                        <tr className='border-style-none'>
                                            <td colSpan={2} className="text-end color-red  p-0"><strong> Amount Paid To Date</strong></td>
                                            <td className='color-red  p-0 text-end'><strong className='ms-2'>
                                                <FormattedNumber value={totalAmount} />
                                            </strong></td>
                                        </tr>
                                        <tr className='border-style-none'>
                                            <td colSpan={2} className="text-end color-red  p-0"><strong>Open Balance</strong></td>
                                            <td className='color-red  p-0 text-end'><strong className='ms-2'>
                                                <FormattedNumber value={(sumRevisedContractAmount)-(totalAmount)} />
                                            </strong></td>
                                        </tr>
                                        <tr className='border-style-none'>
                                            <td colSpan={2} className="text-end color-red  p-1 text-decoration-underline"><strong>Amount Due Upon Acceptance</strong></td>
                                            <td className='color-red  p-0 text-end'><strong className='ms-2'>
                                                <FormattedNumber value={addendaData?.result?.amountPaidUponAcceptance} />
                                            </strong></td>
                                        </tr>
                                        <tr className='border-style-none'>
                                            <td colSpan={3} className="text-end color-red p-1">
                                                <p className='fs-11'>
                                                    * Pending Approval of Current Addendum, if applicable.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr className='border-style-none'>
                                            <td colSpan={3} className="text-end color-red p-0">
                                                <p className='fs-11'>
                                                    ** Items marked with '**' are not yet approved.
                                                </p>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div className='col-md-9 mt-2 mb-2 mt-2'>
                                <h5><i> Other Addenda Not Yet Approved</i></h5>
                                <div style={{ overflow: 'auto' }}>
                                    <table className="table border-style-none" >
                                        <thead className="table-light" style={{ borderBottom: '2px solid', borderTop: '2px solid' }}>
                                            <tr>
                                                <th className=' fs-12 p-1' style={{ width: '72%' }}><i>Nbr</i></th>
                                                <th className=' fs-12 p-1' ><i>Date</i></th>
                                                <th className=' fs-12 p-1 text-end'><i>Sale Amt</i></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {addendaData?.result?.pendingAndVoided?.map((data: any, index: any) => {
                                                return (
                                                    <tr key={data?.id}>
                                                        <td className=' fs-12 p-1'>
                                                            <i>  {data?.addendaNumber}</i>
                                                            {/* {addendaId?.addendaNbr === data?.addendaNumber ? `(Current Addendum-Status : ${addendaId?.status}) ` : ''} {data?.status === 'Approved' ? '' : data?.status !== 'Reviewed' ? '*' : data?.status !== 'Pending' ? "**" : '*'}  */}
                                                        </td>
                                                        <td className=' fs-12 p-1'>
                                                            <i> <DateComp formattedDate={data?.addendaDate} /></i>
                                                        </td>
                                                        <td className=' fs-12 p-1 text-end'>
                                                            <i>
                                                                <FormattedNumber value={data?.saleAmount} />
                                                            </i>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="print-page" style={{ pageBreakAfter: "always" }}>
                        <div className='row p-5 '>
                            <div className='col-md-12'>
                                <h5 className="mt-2 mb-2">Proposed Payment Schedule</h5>
                                <div style={{ overflow: 'auto' }}>
                                    <table className="table border-style-none" >
                                        <thead className="table-light" style={{ borderBottom: '2px solid', borderTop: '2px solid' }}>
                                            <tr>
                                                <th className=' fs-12 p-1'>Payment</th>
                                                <th className=' fs-12 p-1 text-end'>Previous Amt</th>
                                                <th className=' fs-12 p-1 text-end'>Proposed Changes</th>
                                                <th className=' fs-12 p-1 text-end'>New Amt</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {addendaData?.result?.projectPaymentSchedule?.map((data: any, index: any) => (
                                                <tr key={data?.id}>
                                                    <td className=' fs-12 p-1 text-break' style={{ maxWidth: '400px', wordBreak: 'break-word', whiteSpace: 'normal' }}>
                                                        {data?.lst_PaymentType?.value}
                                                    </td>
                                                    <td className=' fs-12 p-1 text-end'>
                                                        <FormattedNumber value={data?.paymentAmt} />
                                                    </td>
                                                    <td className=' fs-12 p-1 text-end'>
                                                        <FormattedNumber value={data?.changeBy} />
                                                    </td>
                                                    <td className=' fs-12 p-1 text-end'>
                                                        <FormattedNumber value={data?.newAmount} />
                                                    </td>
                                                </tr>
                                            ))
                                            }
                                        </tbody>
                                        <tfoot className="table-light" style={{ borderBottom: '2px solid', borderTop: '2px solid' }}>
                                            <tr>
                                                <th className='color-red'>Total</th>
                                                <th className='color-red text-end p-0'>
                                                    <FormattedNumber value={previousAmount} />
                                                </th>
                                                <th className='color-red text-end p-0'>
                                                    <FormattedNumber value={proposedAmount} />
                                                </th>
                                                <th className='color-red text-end p-0'>
                                                    <FormattedNumber value={newAmount} />
                                                </th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <div>
                                <div className='d-flex justify-content-end gap-5 mt-5 '>

                                    <div>
                                        <p className='mb-0' style={{ borderBottom: '2px solid', width: '300px' }}>

                                        </p>
                                        <p className='mb-0 fw-600'>
                                            Buyer
                                        </p>
                                    </div>
                                    <div>
                                        <p className='mb-0' style={{ borderBottom: '2px solid', width: '150px' }}>

                                        </p>
                                        <p className='mb-0 fw-600'>
                                            Date
                                        </p>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-end gap-5 mt-5'>

                                    <div>
                                        <p className='mb-0' style={{ borderBottom: '2px solid', width: '300px' }}>

                                        </p>
                                        <p className='mb-0 fw-600'>
                                            Buyer
                                        </p>
                                    </div>
                                    <div>
                                        <p className='mb-0' style={{ borderBottom: '2px solid', width: '150px' }}>

                                        </p>
                                        <p className='mb-0 fw-600'>
                                            Date
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddendaCard